export { BvlRadioButtonComponent as BvlRadioButton } from './radio-button.component';
export { BvlRadioButtonModule } from './radio-button.module';
